import React from 'react'
import { Card, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import HighchartsWrapper from "./Utils/HighchartsWrapper"
import * as Scroll from "react-scroll";

import { FaLevelDownAlt, FaLevelUpAlt, FaQuestionCircle } from "react-icons/fa"

import vasFigureApiCallService from '../services/vasFigureApiCall.service';
import HelpTextModal from './Utils/HelpTextModal.component';
class VASFigure extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataIsLoaded: false,
            language: this.props.i18n.language,
            options: {
                data: {
                    startDate: this.props.startDate,
                    endDate: this.props.endDate,
                    moduleId: this.props.moduleID
                }
            },
            moduleID: this.props.moduleID,
            isModalOpen: false,
            apiData: null
        };
    }
    // apiData is managed from the vasFigureApiCallservice and 
    // passed as props to highcharts wrapper as data.
    UNSAFE_componentWillMount() {
        this.dataMap = async ({ apiOptions }) => {
            let allData = await vasFigureApiCallService({
                figureCode: this.props.figureCode,
                vasId: this.props.vasId,
                apiOptions
            });
            this.setState({
                dataIsLoaded: true,
                apiData: allData
            })
        }
    }

    // Helptext modal show hide logic
    showHideHelpTextModal = () => {
        this.setState({
            ...this.state,
            isModalOpen: !this.state.isModalOpen
        })
    }
    // requesting data on VASFigure mount
    componentDidMount() {
        this.dataMap({
            apiOptions: this.state.options
        })
        // Added from hoc
        this.setState({
            detailsOf: null,
            detailsChanged: !this.state.detailsChanged
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.chartTitle !== prevProps.chartTitle
            && (this.props.figureCode === 'module-volume' || this.props.figureCode === 'module-turnaround-time')
        ) {//Module dropdown has changed, so get values from props
            this.setState({
                dataIsLoaded: false
            })
            this.dataMap({
                apiOptions: {
                    data: {
                        startDate: this.props.startDate,
                        endDate: this.props.endDate,
                        moduleId: this.props.moduleID
                    }
                }
            })
        } else {
            if (this.state.language !== this.props.i18n.language) {
                this.setState({
                    ...this.state,
                    language: this.props.i18n.language,
                })
            }
            // Make sure the orgId actually changed before doing anything
            if (this.props.selectedOrgId !== prevProps.selectedOrgId) {
                if (this.props.selectedOrgId) {
                    this.setState({
                        dataIsLoaded: true,
                        detailsOf: null
                    })
                }
                // this.fetchData(this.props.selectedOrgId);
            }
            // if any previous properties of graph changes graph reloads.
            if (prevProps !== this.props) {
                this.setState({
                    propsUpdated: !this.state.propsUpdated
                })
            }
        }
    }

    handleOrgDetailsSelectChange = (selectedItem) => {
        this.setState({
            detailsOf: {
                ...this.state.detailsOf,
                selectedOrgId: selectedItem.orgId,
                selectedOrg: selectedItem
            },
            detailsChanged: !this.state.detailsChanged
        })
    }

    // handleDetailsClick is managed using the detailsOf object 
    // and reused everywhere in VasFigureDetails and DetailsGraph Component
    //handleDetailsClick = (props) => {
    //    this.setState({
    //        ...this.state,
    //        detailsOf: {
    //            ...props,
    //            figureCode: `${props.figureCode}-details`,

    //        },
    //        detailsChanged: !this.state.detailsChanged,
    //        // Reset Detail chart filters so that defaults are used for initial display
    //        productionCardDetailsFilter: {},
    //        sampleLoadingDetailsfilter: {},
    //        tatDetailsFilter: {}
    //    })
    //}

    handleCloseClick = () => {
        this.setState({
            ...this.state,
            detailsOf: null
        })
        // Scroll.animateScroll.scrollTo(scrollBackTo);
    }

    render() {
        const {
            t,
            figureCode,
            selectedOrgId,
            vasId,
            labels,
            labelKey,
            extraDetailsOptions,
            extraOptions,
            scrollTo,
            scrollBackTo,
            handleCloseClick,
            handleDetailsClick,
            detailsHelpTextObject
        } = this.props;

        //const handleDetailsClick = handleDetailsClick;

        return (
            this.state.dataIsLoaded
                ?
                <div className="row" id={figureCode} style={{ pageBreakAfter: "always", width: "100%" }}>
                    <Card className="w-100">
                        <Card.Body >
                            <div className="d-flex justify-content-between px-4">
                                <h5 className="text-dark mb-4">{labels?.containerLabel}</h5>
                                {/* <h6>{selectedOrgId}</h6> */}
                                {/* <Col md={6}> <h6>{figureCode}</h6> </Col> */}
                                <div className="pr-2"> {handleDetailsClick &&
                                    <>
                                        <Scroll.Link
                                            to={scrollTo}
                                            smooth={true}
                                            className="text-primary cursor-pointer"
                                            onClick={(e) => handleDetailsClick({
                                                selectedOrgId,
                                                vasId,
                                                figureCode,
                                                labelKey,
                                                extraDetailsOptions,
                                                detailsHelpTextObject
                                            })}
                                        >{t("highcharts.details")}<FaLevelDownAlt /></Scroll.Link>

                                    </>}
                                    {handleCloseClick && <Scroll.Link
                                        to={scrollBackTo}
                                        smooth={true}
                                        className="text-danger cursor-pointer"
                                        onClick={handleCloseClick}
                                    >{t("highcharts.close")}<FaLevelUpAlt /></Scroll.Link>}
                                    <FaQuestionCircle
                                        className="cursor-pointer ml-1"
                                        style={{ color: "#0056b3" }}
                                        onClick={this.showHideHelpTextModal}
                                    />
                                    {
                                        this.state.isModalOpen &&
                                        <HelpTextModal
                                            isOpen={this.state.isModalOpen}
                                            showHideHelpTextModal={this.showHideHelpTextModal}
                                            helpTextObject={handleCloseClick ? this.props?.detailsOf?.detailsHelpTextObject : this.props.helpTextObject}
                                        />
                                    }
                                </div>
                            </div>
                            <div className="chart-wrapper">
                                <div className="chart-inner">
                                    <HighchartsWrapper
                                        propsUpdated={this.props.propsUpdated}
                                        detailsChanged={this.props.detailsChanged}
                                        // if !handleCloseClick then passing extraOptions, else passing extradetailsOptions
                                        chartOptions={!handleCloseClick ? extraOptions : this.props?.detailsOf?.extraDetailsOptions}
                                        chartTitle={this.props.chartTitle}
                                        labels={labels}
                                        apiData={this.state.apiData}
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                : <Spinner animation="border" />
        );
    }
}

export default withTranslation()(VASFigure);